export const dateParser = (date: Date): string =>
    new Date(date)
        .toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        })
        .replace(/\//g, '.')
